<template>
  <van-popup 
    v-model="visible" 
    position="bottom"
    get-container="body"
    :style="{ width: '100%',height: '100%' }">
    <van-nav-bar @click-left="oncancel" class="navbar" title="二次认证">
      <van-icon name="cross" size="20" slot="left" />
    </van-nav-bar>
    <van-form @submit="onconform" validate-first ref="form" class="van-form-offset">
      <van-field
        v-model="cellphone"
        name="cellphone"
        label="手机号"
        placeholder="请输入手机号"
        required
        :error="false"
        :rules="[{ required: true, message: '请输入手机号' },{ pattern, message: '无效的手机号' }]"
      />
      <van-field
        v-model="code"
        name="code"
        label="验证码"
        placeholder="请输入验证码"
        required
        :error="false"
        :rules="[{ required: true, message: '请填写验证码' }]"
      >
        <template #button>
          <van-button size="small" type="info" @click.native="sendCode" native-type="button" :disabled="loading || count > 0">{{ count > 0 ? `获取中(${count})` : '获取验证码' }}</van-button>
        </template>
      </van-field>
      <div style="position: absolute; bottom: 0; width: 100%;">
        <van-button block type="info" native-type="submit" :disabled="!(code && cellphone)">验证</van-button>
      </div>
    </van-form>
  </van-popup>
</template>
<script>
  import { getVerificationCode, checkVerificationCode } from '@/api/comment'
  export default {
    name: "second-verification",
    data() {
      return {
        visible: !!this.value,
        cellphone: '',
        code: '',
        pattern: /^1[3|4|5|7|8][0-9]{9}$/,
        count: -1,
        loading: false,
        timer: null
      }
    },
    props: {
      value: Boolean
    },
    watch: {
      value(val) {
        this.visible = val; 
      },
      visible(val) {
        this.$emit('input', val);
      }
    },
    methods: {
      oncancel() {
        this.visible = false;
        this.loading = false;
        this.count = -1;
        if(this.timer) clearInterval(this.timer);
        this.cellphone = "";
        this.code = "";
        this.$refs["form"].resetValidation();
      },
      onconform() {
        this.$refs["form"].validate().then(valid => {
          if (!valid) {
            checkVerificationCode({
              mobile: this.cellphone,
              verificationCode: this.code
            }).then(res => {
              if(res.code == '0' && res.datas.checkVerificationCode) {
                this.$emit('on-pass');
                this.oncancel();
              } else {
                this.$notify({ type: 'danger', message: res.msg || '校验失败'});
              }
            })
          }
        })
      },
      sendCode() {
        this.$refs["form"].validate("cellphone").then(valid => {
          if(!valid) {
            this.loading = true;
            getVerificationCode({
              "mobile": this.cellphone
            }).then(res => {
              this.loading = false;
              if(res.code == '0') {
                let count = this.count = 60;
                this.timer = setInterval(() =>{
                  this.count = count--;
                  if (this.count <=0) {
                    clearInterval(this.timer);
                  }
                }, 1000)
              } else {
                this.$notify({ type: 'danger', message: res.msg || '验证码获取失败'});
              }
            })
          }
        });
      }
    }
  }
</script>
<style lang="css" scoped>
  .van-form-offset .van-cell {
    font-size: 16px;
    line-height: 32px;
  }
  .van-form-offset .van-field__button .van-button {
    vertical-align: bottom;
  }
</style>